var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetamsak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.344727,
    y: 0.435547,
    width: 39.6474,
    height: 39.6474,
    rx: 19.8237,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0844 20.2416L32.2468 18.877L31.7414 18.5064L32.5501 17.7651L31.9267 17.2934L32.7354 16.6869L32.2131 16.2825L33.0555 12.1718L31.7751 8.36426M31.7751 8.36426L23.5536 11.4136H16.6967L8.47522 8.36426L7.19482 12.1718L8.05404 16.2825L7.51492 16.6869L8.34044 17.2934L7.71709 17.7651L8.52577 18.5064L8.02034 18.877L9.18281 20.2416L7.41384 25.7002L9.04803 31.2767L14.793 29.693L15.9049 30.6028L18.1793 32.1527H22.071L24.3454 30.6028L25.4574 29.693L31.2191 31.2767L32.8702 25.7002L31.0844 20.2416",
    fill: "#F5841F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7752 8.36426L21.6836 15.7939L23.5536 11.4136L31.7752 8.36426Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47522 8.36426L18.4825 15.8613L16.6967 11.4136L8.47522 8.36426Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.153 25.5986L25.4574 29.6757L31.2192 31.2593L32.8702 25.6829L28.153 25.5986Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41394 25.6829L9.04813 31.2593L14.7931 29.6757L12.1144 25.5986L7.41394 25.6829Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4898 18.6913L12.8893 21.1004L18.5837 21.3531L18.3984 15.2544L14.4898 18.6913Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7775 18.6917L21.8015 15.1875L21.6836 21.3536L27.378 21.1009L25.7775 18.6917Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.793 29.6762L18.2467 28.0251L15.2647 25.7339L14.793 29.6762Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0205 28.0251L25.4574 29.6762L24.9856 25.7339L22.0205 28.0251Z",
    fill: "#E27625"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4574 29.6759L22.0205 28.0249L22.3069 30.2488L22.2732 31.1922L25.4574 29.6759Z",
    fill: "#D7C1B3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.793 29.6759L17.994 31.1922L17.9771 30.2488L18.2467 28.0249L14.793 29.6759Z",
    fill: "#D7C1B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0446 24.2516L15.1974 23.4261L17.2191 22.4995L18.0446 24.2516Z",
    fill: "#2F343B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2059 24.2516L23.0483 22.4995L25.07 23.4261L22.2059 24.2516Z",
    fill: "#2F343B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.793 29.6757L15.2984 25.5986L12.1143 25.6829L14.793 29.6757Z",
    fill: "#CC6228"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 25.5986L25.4573 29.6757L28.1529 25.6829L24.9688 25.5986Z",
    fill: "#CC6228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.378 21.1006L21.6836 21.3533L22.2059 24.251L23.0482 22.4989L25.0699 23.4255L27.378 21.1006Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1974 23.4255L17.2191 22.4989L18.0446 24.251L18.5837 21.3533L12.8893 21.1006L15.1974 23.4255Z",
    fill: "#CC6228"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8893 21.1006L15.2648 25.7336L15.1974 23.4255L12.8893 21.1006Z",
    fill: "#E27625"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0701 23.4255L24.9858 25.7336L27.3782 21.1006L25.0701 23.4255Z",
    fill: "#E27625"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5837 21.3535L18.0446 24.2513L18.7184 27.6881L18.8701 23.173L18.5837 21.3535Z",
    fill: "#E27625"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6836 21.3535L21.3972 23.1562L21.532 27.6881L22.2059 24.2513L21.6836 21.3535Z",
    fill: "#E27625"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2059 24.2513L21.532 27.6882L22.0206 28.0251L24.9857 25.7339L25.0699 23.4258L22.2059 24.2513Z",
    fill: "#F5841F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1974 23.4258L15.2648 25.7339L18.2468 28.0251L18.7185 27.6882L18.0446 24.2513L15.1974 23.4258Z",
    fill: "#F5841F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2732 31.192L22.3069 30.2486L22.0373 30.0296H18.213L17.9771 30.2486L17.994 31.192L14.793 29.6758L15.9049 30.5855L18.1793 32.1523H22.071L24.3454 30.5855L25.4573 29.6758L22.2732 31.192Z",
    fill: "#C0AD9E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0205 28.0249L21.532 27.688H18.7185L18.2467 28.0249L17.9772 30.2488L18.213 30.0298H22.0374L22.3069 30.2488L22.0205 28.0249Z",
    fill: "#2F343B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2132 16.2825L33.0555 12.1718L31.7751 8.36426L22.0205 15.5412L25.7775 18.6917L31.0844 20.2416L32.2469 18.877L31.7414 18.5064L32.5501 17.7819L31.9268 17.2934L32.7354 16.6869L32.2132 16.2825Z",
    fill: "#763E1A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19482 12.1718L8.05404 16.2825L7.51492 16.6869L8.3236 17.3102L7.70024 17.7819L8.50892 18.5064L8.0035 18.877L9.18281 20.2416L14.4897 18.6917L18.2467 15.5412L8.47522 8.36426L7.19482 12.1718Z",
    fill: "#763E1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0846 20.2419L25.7777 18.6919L27.3782 21.1011L24.9858 25.7341L28.1531 25.6835H32.8704L31.0846 20.2419Z",
    fill: "#F5841F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4898 18.6919L9.18291 20.2419L7.41394 25.6835H12.1144L15.2648 25.7341L12.8893 21.1011L14.4898 18.6919Z",
    fill: "#F5841F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6836 21.353L22.0205 15.5407L23.5536 11.4131H16.6968L18.2467 15.5407L18.5837 21.353L18.7185 23.1725V27.6876H21.532L21.5488 23.1725L21.6836 21.353Z",
    fill: "#F5841F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamsak);
export default __webpack_public_path__ + "static/media/metamsak.a5824e6e6cf60dc988914a0d0c6e0ec5.svg";
export { ForwardRef as ReactComponent };